import _TopRight from 'src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
import React from 'react';
import { useHistory, useParams } from 'react-router';
import { get } from 'lodash';
import { EnumMultiLanguageType } from 'src/constrains/SalesChannelMultiLanguageSelect';
import MultiLangDropDown from '@/src/constrains/SalesChannelMultiLanguageSelect/MultiLangDropDown';

const TopRight = (props) => {
  const {
    hasModified,
    onSubmit,

    isNew,
  } = props;

  const s = useParams();
  const salesChannelUuid = get(s, 'uuid');

  const h = useHistory();
  const onD = () => {
    h.push(`/salesChannel/promotionTagList/${salesChannelUuid}`);
  };
  return (
    <_TopRight
      onDiscard={onD}
      onSaveDisable={!hasModified}
      onSubmit={onSubmit}
      //extendButton={isPrimary ? rightBtnGenerator() : null}
      extraLeft={
        isNew ? null : (
          <div style={{ marginRight: 8 }}>
            <MultiLangDropDown
              customType={EnumMultiLanguageType.SalesChannelProductPromotionTag}
              hasModified={hasModified}
              salesChannelUuidKey='uuid'
            />
          </div>
        )
      }
    />
  );
};
export default TopRight;
